import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  Grid,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Alert,
  Divider,
  Container,
  Paper,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
  FormControlLabel,
  Tabs,
  Tab,
  Menu,
  MenuItem as MuiMenuItem,
  ListItemIcon,
  ListItemText,
  Stack
} from '@mui/material';
import {
  Add,
  Edit,
  Delete,
  TableRestaurant,
  People,
  CheckCircle,
  Cancel,
  AccessTime,
  Image,
  Link,
  QrCode,
  ContentCopy,
  OpenInNew,
  Event,
  Person,
  Phone,
  Email,
  Done,
  MoreVert,
  AddCircle,
  Payments,
  MeetingRoom,
  CleaningServices,
  Restaurant,
  Download, ToggleOff, ToggleOn,
  Dangerous
} from '@mui/icons-material';
import { tableService } from '../../services/tableService';
import outletService from '../../services/outletService';
import { buildImageUrl } from '../../utils/imageUtils';
import { useCustomTheme } from '../../contexts/ThemeContext';
import { useNotification } from '../../contexts/NotificationContext';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";



const TableAdditionManagement = ({tableIdForCloseBill,setTableIdForCloseBill}) => {
  const theme = useTheme();
  const { isDarkMode } = useCustomTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  const [activeTab, setActiveTab] = useState(1);
  const [reservationSubTab, setReservationSubTab] = useState(0);
  const [assignTableDialog, setAssignTableDialog] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedTableForRequest, setSelectedTableForRequest] = useState('');
  const [outlets, setOutlets] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState(0);
  const [tables, setTables] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableDialog, setTableDialog] = useState(false);
  const [editingTable, setEditingTable] = useState(null);
  const [tableForm, setTableForm] = useState({
    name: '',
    table_number: '',
    capacity: 4,
    outlet_id: '',
    image: null,
    is_active: true,
    is_available: true
  });
  const [submitting, setSubmitting] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const { showSuccess, showError } = useNotification();

  // Admin response states
  const [responseDialog, setResponseDialog] = useState(false);
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [responseForm, setResponseForm] = useState({
    status: 'confirmed',
    admin_notes: '',
    response_message: ''
  });

  // Menu state for each table card - using MUI Menu for better handling
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTableForMenu, setSelectedTableForMenu] = useState(null);
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)

  useEffect(() => {
    loadOutlets();
  }, []);

  useEffect(() => {
    console.log("tableIdForCloseBill changed:", tableIdForCloseBill);
    loadTables();
    // loadReservations();
  }, [selectedOutlet,tableIdForCloseBill]);

  // useEffect(() => {
  //   loadReservations();
  // }, [toDate]);

  const loadOutlets = async () => {
    try {
      const response = await outletService.getOutlets();
      setOutlets(response || []);
      if (response && response.length > 0) {
        let admin_outlet_id = JSON.parse(localStorage.getItem('admin_outlet_id'));
        if (admin_outlet_id) {
          setSelectedOutlet(admin_outlet_id);
        } else {
          setSelectedOutlet(0);
        }

        setTableForm(prev => ({ ...prev, outlet_id: response[0].id }));
      }
    } catch (error) {
      console.error('Failed to load outlets:', error);
      setOutlets([]);
    }
  };

  const loadTables = async () => {
    try {
      setLoading(true);
      const response = await tableService.getAdminTables(selectedOutlet);
      setTables(response || []);
    } catch (error) {
      console.error('Failed to load tables:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadReservations = async () => {
    try {
      if(fromDate) fromDate.format("YYYY-MM-DD") 
      if(toDate) toDate.format("YYYY-MM-DD")

      const pendingRequests = await tableService.getAdminReservations(selectedOutlet, 'pending_request',fromDate,toDate);
      setReservations(pendingRequests || []);
    } catch (error) {
      console.error('Failed to load reservation requests:', error);
      setReservations([]);
    }
  };

  const handleOutletChange = (outletId) => {
    setSelectedOutlet(outletId);
    setTableForm(prev => ({ ...prev, outlet_id: outletId }));
  };

  const openTableDialog = (table = null) => {
    if (table) {
      setEditingTable(table);
      setTableForm({
        name: table.name,
        table_number: table.table_number,
        capacity: table.capacity,
        outlet_id: table.outlet_id,
        image: null,
        is_active: table.is_active,
        is_available: table.is_available
      });
      setImagePreview(table.image_url ? buildImageUrl(table.image_url) : null);
    } else {
      setEditingTable(null);
      setTableForm({
        name: '',
        table_number: '',
        capacity: 4,
        outlet_id: selectedOutlet,
        image: null,
        is_active: true,
        is_available: true
      });
      setImagePreview(null);
    }
    setTableDialog(true);
  };

  const closeTableDialog = () => {
    setTableDialog(false);
    setEditingTable(null);
    setTableForm({
      name: '',
      table_number: '',
      capacity: 4,
      outlet_id: selectedOutlet,
      image: null,
      is_active: true,
      is_available: true
    });
    setImagePreview(null);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setTableForm(prev => ({ ...prev, image: file }));
      const reader = new FileReader();
      reader.onload = (e) => setImagePreview(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmitTable = async () => {
    try {
      setSubmitting(true);
      console.log("Form => ", tableForm);
      if (tableForm.name.length > 70) {
        showError("Please Give Table Name below 70 characters")
        return;
      }

      if (tableForm.table_number.length > 20) {
        showError("Please Give Table Number below 20 characters")
        return;
      }

      if (editingTable) {
        await tableService.updateTable(editingTable.id, tableForm);
      } else {
        await tableService.createTable(tableForm);
      }

      closeTableDialog();
      loadTables();

    } catch (error) {
      console.error('Failed to submit table:', error);
      showError(error.response?.data?.detail || 'Failed to submit table');
    } finally {
      setSubmitting(false);
    }
  };

  const handleDeleteTable = async (tableId) => {

    try {
      await tableService.deleteTable(tableId);
      loadTables();
    } catch (error) {
      console.error('Failed to delete table:', error);
      showError('Failed to delete table. Please try again.');
    }
    handleMenuClose()

  };

  const handleReservationStatusUpdate = async (reservationId, newStatus) => {
    try {
      await tableService.updateReservationStatus(reservationId, newStatus);
      loadReservations();
      showSuccess(`Reservation ${newStatus} successfully!`);
    } catch (error) {
      console.error('Failed to update reservation status:', error);
      showError('Failed to update reservation status. Please try again.');
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed': return 'success';
      case 'pending': return 'warning';
      case 'pending_request': return 'warning';
      case 'cancelled': return 'error';
      case 'completed': return 'info';
      default: return 'default';
    }
  };

  const openResponseDialog = (reservation) => {
    setSelectedReservation(reservation);
    setResponseForm({
      status: reservation.status,
      admin_notes: reservation.admin_notes || '',
      response_message: ''
    });
    setResponseDialog(true);
  };

  const handleResponseSubmit = async () => {
    if (!selectedReservation) return;

    try {
      await tableService.updateReservationStatus(selectedReservation.id, responseForm.status, {
        admin_notes: responseForm.admin_notes,
        response_message: responseForm.response_message
      });

      loadReservations();
      setResponseDialog(false);
      setSelectedReservation(null);
      showSuccess(`Reservation ${responseForm.status} successfully!`);
    } catch (error) {
      console.error('Failed to update reservation:', error);
      showError('Failed to update reservation. Please try again.');
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'confirmed': return <CheckCircle />;
      case 'pending': return <AccessTime />;
      case 'pending_request': return <Event />;
      case 'cancelled': return <Cancel />;
      case 'completed': return <CheckCircle />;
      default: return <AccessTime />;
    }
  };

  const openAssignTableDialog = (request) => {
    setSelectedRequest(request);
    setSelectedTableForRequest('');
    setAssignTableDialog(true);
  };

  const handleAssignTable = async () => {
    if (!selectedRequest || !selectedTableForRequest) {
      showError('Please select a table');
      return;
    }

    try {
      await tableService.assignTableToRequest(selectedRequest.id, selectedTableForRequest);
      setAssignTableDialog(false);
      setSelectedRequest(null);
      setSelectedTableForRequest('');
      loadReservations();
      showSuccess('Table assigned successfully!');
    } catch (error) {
      console.error('Failed to assign table:', error);
      showError('Failed to assign table. Please try again.');
    }
  };

  const getFilteredReservations = () => {
    if (reservationSubTab === 0) {
      return reservations.filter(r => r.status !== 'completed');
    } else {
      return reservations.filter(r => r.status === 'completed');
    }
  };

  const getOutletName = (outletId) => {
    const outlet = outlets.find(o => o.id === outletId);
    return outlet ? outlet.name : 'Unknown Outlet';
  };

  // Menu handlers using MUI Menu
  const handleMenuOpen = (event, table) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedTableForMenu(table);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedTableForMenu(null);
  };

  const handleCopyLink = () => {
    if (selectedTableForMenu?.link) {
      navigator.clipboard.writeText(selectedTableForMenu.link);
      showSuccess('Link copied to clipboard');
    }
    handleMenuClose();
  };

  const handleViewQr = () => {
    if (selectedTableForMenu?.qr_code_url) {
      window.open(buildImageUrl(selectedTableForMenu.qr_code_url), '_blank');
    }
    handleMenuClose();
  };

  const handleDownloadQr = async () => {
    if (selectedTableForMenu?.qr_code_url) {
      await tableService.downloadTableQRCode(selectedTableForMenu.id);
      showSuccess('QR Code downloaded');
    }
    handleMenuClose();
  };

  return (
    <Container maxWidth="xl" sx={{ py: { xs: 2, sm: 3 } }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={600} gutterBottom>
          Table Additions
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage Dine In and Tables
        </Typography>
      </Box>

      {/* Outlet Selection */}
      <Paper elevation={2} sx={{ p: { xs: 2, sm: 3 }, mb: 3 }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          alignItems={{ md: "center" }}
        >
          <FormControl fullWidth sx={{ maxWidth: 300 }}>
            <InputLabel>Select Outlet</InputLabel>
            <Select
              disabled={JSON.parse(localStorage.getItem("admin_outlet_id")) ? true : false}
              value={selectedOutlet}
              onChange={(e) => handleOutletChange(e.target.value)}
              label="Select Outlet"
            >
              <MenuItem value={0}>All</MenuItem>
              {outlets.map((outlet) => (
                <MenuItem key={outlet.id} value={outlet.id}>
                  {outlet.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From Date"
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  // fullWidth: true,
                },
              }}
              value={fromDate}
              onChange={(newValue) => setFromDate(newValue)}
            />

            <DatePicker
              label="To Date"
              format="DD/MM/YYYY"
              disabled={!fromDate}
              minDate={fromDate}
              slotProps={{
                textField: {
                  size: "small",
                  // fullWidth: true,
                },
              }}
              value={toDate}
              onChange={(newValue) => setToDate(newValue)}
            />
          </LocalizationProvider> */}
          {/* <Button variant='contained' onClick={()=>{
            setFromDate(null)
            setToDate(null)
          }}> Clear Filters </Button> */}
        </Stack>
      </Paper>

      {/* Main Tabs */}
      {/* <Paper elevation={2} sx={{ mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          variant={isMobile ? "scrollable" : "fullWidth"}
          scrollButtons={isMobile ? "auto" : false}
        >
          <Tab label="Reservations" icon={<Event />} />
          <Tab label="Table Additions 2" icon={<TableRestaurant />} />
        </Tabs>
      </Paper> */}

      {/* Reservations Tab */}
      {activeTab === 0 && (
        <Paper elevation={2} sx={{ p: { xs: 2, sm: 3 } }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
            <Tabs
              value={reservationSubTab}
              onChange={(e, newValue) => setReservationSubTab(newValue)}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                label={`Pending Requests (${reservations.filter(r => r.status !== 'completed').length})`}
                sx={{ fontWeight: reservationSubTab === 0 ? 600 : 400 }}
              />
              <Tab
                label={`All Others (${reservations.filter(r => r.status === 'completed').length})`}
                sx={{ fontWeight: reservationSubTab === 1 ? 600 : 400 }}
              />
            </Tabs>
          </Box>

          {getFilteredReservations().length === 0 ? (
            <Alert severity="info" sx={{ textAlign: 'center', py: 4 }}>
              No {reservationSubTab === 0 ? 'pending' : ''} reservations found for this outlet.
            </Alert>
          ) : (
            <>
              <TableContainer sx={{ display: { xs: 'none', md: 'block' }, width: '100%', overflowX: 'auto' }}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: theme.palette.action.hover }}>
                      <TableCell sx={{ fontWeight: 600 }}>Request #</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Table</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Outlet</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Customer</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Booked Date & Time</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Guests</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getFilteredReservations().map((reservation) => (
                      <TableRow key={reservation.id} sx={{ '&:hover': { bgcolor: theme.palette.action.hover } }}>
                        <TableCell>
                          <Typography variant="body2" fontWeight={500}>
                            {reservation.reservation_number}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {reservation.status === 'pending_request'
                              ? 'No Table Assigned'
                              : reservation.status !== 'pending_request' && reservation.table === null
                                ? "Custom"
                                : `${reservation.table?.name || 'N/A'} (${reservation.table?.table_number || 'N/A'})`
                            }
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">{reservation.outlet_name}</Typography>
                        </TableCell>
                        <TableCell>
                          <Box>
                            <Typography variant="body2" fontWeight={600}>
                              {reservation.customer_name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" display="block">
                              {reservation.customer_phone}
                            </Typography>
                            {reservation.customer_email && (
                              <Typography variant="caption" color="text.secondary" display="block">
                                {reservation.customer_email}
                              </Typography>
                            )}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box>
                            <Typography variant="body2">{reservation.reservation_date}</Typography>
                            <Typography variant="caption" color="text.secondary">
                              {reservation.reservation_time}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell align="center">
                          <Chip icon={<People sx={{ fontSize: 16 }} />} label={reservation.guest_count} size="small" variant="outlined" />
                        </TableCell>
                        <TableCell>
                          <Chip
                            icon={getStatusIcon(reservation.status)}
                            label={reservation.status !== "pending_request" ? reservation.status.toUpperCase() : "PENDING"}
                            color={getStatusColor(reservation.status)}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {reservation.status === 'pending_request' && (
                              <IconButton
                                color="primary"
                                size="small"
                                onClick={() => openAssignTableDialog(reservation)}
                                title="Assign Table"
                                sx={{ backgroundColor: theme.palette.primary.main, color: 'white', '&:hover': { backgroundColor: theme.palette.primary.dark } }}
                              >
                                <TableRestaurant fontSize="small" />
                              </IconButton>
                            )}
                            {reservation.status === 'pending' && (
                              <>
                                <IconButton
                                  color="success"
                                  size="small"
                                  onClick={() => handleReservationStatusUpdate(reservation.id, 'confirmed')}
                                  title="Confirm Reservation"
                                  sx={{ backgroundColor: theme.palette.success.main, color: 'white', '&:hover': { backgroundColor: theme.palette.success.dark } }}
                                >
                                  <CheckCircle fontSize="small" />
                                </IconButton>
                                <IconButton
                                  color="error"
                                  size="small"
                                  onClick={() => handleReservationStatusUpdate(reservation.id, 'cancelled')}
                                  title="Cancel Reservation"
                                  sx={{ backgroundColor: theme.palette.error.main, color: 'white', '&:hover': { backgroundColor: theme.palette.error.dark } }}
                                >
                                  <Cancel fontSize="small" />
                                </IconButton>
                              </>
                            )}
                            {reservation.status === 'confirmed' && (
                              <IconButton
                                color="info"
                                size="small"
                                onClick={() => handleReservationStatusUpdate(reservation.id, 'completed')}
                                title="Mark as Completed"
                                sx={{ backgroundColor: theme.palette.info.main, color: 'white', '&:hover': { backgroundColor: theme.palette.info.dark } }}
                              >
                                <CheckCircle fontSize="small" />
                              </IconButton>
                            )}
                            {reservation.status !== "completed" && (
                              <IconButton
                                color="primary"
                                size="small"
                                onClick={() => openResponseDialog(reservation)}
                                title="Send Response"
                                sx={{ backgroundColor: theme.palette.primary.light, color: 'white', '&:hover': { backgroundColor: theme.palette.primary.main } }}
                              >
                                <Email fontSize="small" />
                              </IconButton>
                            )}
                            {reservation.status === "completed" && (
                              <Chip icon={<CheckCircle />} label="Completed" color="success" size="small" sx={{ fontWeight: 500 }} />
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                {getFilteredReservations().map((reservation) => (
                  <Card key={reservation.id} sx={{ mb: 2, p: 2, '&:hover': { bgcolor: theme.palette.action.hover } }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                          <Typography variant="subtitle2" fontWeight={600}>
                            {reservation.reservation_number}
                          </Typography>
                          <Chip
                            icon={getStatusIcon(reservation.status)}
                            label={reservation.status !== "pending_request" ? reservation.status.toUpperCase() : "PENDING"}
                            color={getStatusColor(reservation.status)}
                            size="small"
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Customer</Typography>
                        <Typography variant="body2" fontWeight={500}>{reservation.customer_name}</Typography>
                        <Typography variant="caption" color="text.secondary">{reservation.customer_phone}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Date & Time</Typography>
                        <Typography variant="body2">{reservation.reservation_date}</Typography>
                        <Typography variant="caption" color="text.secondary">{reservation.reservation_time}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Table</Typography>
                        <Typography variant="body2">
                          {reservation.status === 'pending_request'
                            ? 'No Table Assigned'
                            : reservation.status !== 'pending_request' && reservation.table === null
                              ? "Custom"
                              : `${reservation.table?.name || 'N/A'}`
                          }
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Guests</Typography>
                        <Chip icon={<People sx={{ fontSize: 16 }} />} label={reservation.guest_count} size="small" variant="outlined" />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="caption" color="text.secondary">Actions</Typography>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
                          {reservation.status === 'pending_request' && (
                            <Button variant="contained" color="primary" size="small" onClick={() => openAssignTableDialog(reservation)} startIcon={<TableRestaurant />}>
                              Assign Table
                            </Button>
                          )}
                          {reservation.status === 'pending' && (
                            <>
                              <Button variant="outlined" color="success" size="small" onClick={() => handleReservationStatusUpdate(reservation.id, 'confirmed')}>
                                Confirm
                              </Button>
                              <Button variant="outlined" color="error" size="small" onClick={() => handleReservationStatusUpdate(reservation.id, 'cancelled')}>
                                Cancel
                              </Button>
                            </>
                          )}
                          {reservation.status === 'confirmed' && (
                            <Button variant="outlined" color="info" size="small" onClick={() => handleReservationStatusUpdate(reservation.id, 'completed')}>
                              Complete
                            </Button>
                          )}
                          {reservation.status !== "completed" && (
                            <Button variant="outlined" color="primary" size="small" onClick={() => openResponseDialog(reservation)} startIcon={<Email />}>
                              Respond
                            </Button>
                          )}
                          {reservation.status === "completed" && (
                            <Chip icon={<CheckCircle />} label="Completed" color="success" size="small" />
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                ))}
              </Box>
            </>
          )}
        </Paper>
      )}

      {/* Tables Tab - New Card Design */}
      {activeTab === 1 && (
        <Paper elevation={2} sx={{ p: { xs: 2, sm: 3 } }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
            <Typography variant="h5" fontWeight={600}>
              Table Additions
            </Typography>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => openTableDialog()}
              sx={{ minWidth: 120 }}
            >
              Add Table
            </Button>
          </Box>

          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress size={60} />
            </Box>
          ) : tables.length === 0 ? (
            <Alert severity="info" sx={{ textAlign: 'center', py: 4 }}>
              No tables found for this outlet. Add your first table to get started.
            </Alert>
          ) : (
            <Box sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)' },
              gap: 3
            }}>
              {tables.map((table) => {
                const isAvailable = table.track.status === "FREE";
                const occupiedSeats = Math.floor(Math.random() * (table.capacity + 1));
                const orderTotal = isAvailable ? null : Math.floor(Math.random() * 150) + 20;
                const orderTime = isAvailable ? null : Math.floor(Math.random() * 60) + 5;
                const progressPercent = isAvailable ? 0 : Math.floor(Math.random() * 100);

                return (
                  <Box
                    key={table.id}
                    sx={{
                      // minHeight: 100,
                      bgcolor: 'background.paper',
                      borderRadius: '6px',
                      boxShadow: '0px 4px 12px rgba(0,0,0,0.05)',
                      borderTop: `4px solid ${isAvailable ? '#22c55e' : '#f97316'}`,
                      overflow: 'hidden',
                      display: 'flex',
                      flexDirection: 'column',
                      transition: 'all 0.2s',
                      '&:hover': {
                        boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
                      }
                    }}
                  >
                    <Box sx={{ pr: 2.5, pl: 2.5, pt: 2.5, flex: 1 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                        <Box>
                          <Typography variant="h6" fontWeight={700}>
                            {table.name}
                          </Typography>
                          <Typography variant="h6" fontWeight={700}>
                            {table.table_number}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {getOutletName(table.outlet_id)}
                          </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
                          {table.is_active &&
                            <Chip
                              label={isAvailable ? 'Available' : 'Occupied'}
                              size="small"
                              sx={{
                                bgcolor: isAvailable ? '#dcfce7' : '#ffedd5',
                                color: isAvailable ? '#166534' : '#9a3412',
                                fontWeight: 600,
                                fontSize: '0.7rem',
                              }}
                            />}
                          <IconButton
                            size="small"
                            onClick={(e) => handleMenuOpen(e, table)}
                            sx={{ p: 0.5 }}
                          >
                            <MoreVert fontSize="small" />
                          </IconButton>
                        </Box>
                      </Box>

                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: 'text.secondary', mb: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <People fontSize="small" />
                          <Typography variant="body2">
                            {table.capacity} seats
                          </Typography>
                        </Box>
                      </Box>

                      {!isAvailable ? (
                        <Box sx={{ bgcolor: 'action.hover', p: 1.5, borderRadius: 2, mb: 2 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                            <Typography variant="caption" color="text.secondary">
                              Ordered: {table.track.ordered_at}
                            </Typography>
                            <Typography variant="body2" fontWeight={700} color="primary">
                              S${table.track.total_amount}
                            </Typography>
                          </Box>
                          {/* <Box sx={{ width: '100%', bgcolor: 'divider', height: 4, borderRadius: 2, overflow: 'hidden' }}>
                            <Box sx={{ width: `${progressPercent}%`, bgcolor: 'primary.main', height: '100%' }} />
                          </Box> */}
                        </Box>
                      ) : (
                        table.is_active ? (
                          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', py: 1, color: 'text.secondary', border: '1px dashed', borderColor: 'divider', borderRadius: 2, mb: 0.5 }}>
                            <Restaurant sx={{ fontSize: 40, mr: 1, opacity: 0.7 }} />
                            <Typography variant="caption">Ready for guests</Typography>
                          </Box>) : (
                          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', py: 1, color: 'text.secondary', border: '1px dashed', borderColor: 'divider', borderRadius: 2, mb: 0.5 }}>
                            <Dangerous sx={{ fontSize: 40, mr: 1, opacity: 0.7 }} />
                            <Typography variant="caption">Not Available</Typography>
                          </Box>
                        )
                      )}
                    </Box>

                    <Box sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))', gap: 1.5 }}>
                      {table.is_active ? (
                        <>
                          <Button
                            variant="contained"
                            size="small"
                            startIcon={<AddCircle />}
                            sx={{ textTransform: 'none' }}
                            fullWidth={!isAvailable}
                            onClick={() => {
                              const user_id = localStorage.getItem('user_id');
                              sessionStorage.setItem('user_id', user_id);
                              sessionStorage.removeItem('cart_draw');
                              window.open(table.link, '_blank');
                            }}
                          >
                            Add Order
                          </Button>

                          {!isAvailable && (
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<Payments />}
                              sx={{ textTransform: 'none' }}
                              onClick={() => {
                                const user_id = localStorage.getItem('user_id');
                                sessionStorage.setItem('user_id', user_id);
                                sessionStorage.setItem('cart_draw', true);
                                window.open(table.link, '_blank');
                              }}
                            >
                              Close Bill
                            </Button>
                          )}
                        </>
                      ) : (
                        <Typography color="error">
                          Table is Inactive
                        </Typography>
                      )}
                    </Box>
                  </Box>
                );
              })}
            </Box>
          )}
        </Paper>
      )}

      {/* MUI Menu for 3-dots */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            width: 180,
            borderRadius: 2,
            boxShadow: '0px 4px 12px rgba(0,0,0,0.15)',
          }
        }}
      >

        {selectedTableForMenu?.is_active &&
          <>
            <MuiMenuItem onClick={handleViewQr} sx={{ gap: 1 }}>
              <QrCode fontSize="small" />
              <ListItemText>View QR Code</ListItemText>
            </MuiMenuItem>

            <MuiMenuItem onClick={handleCopyLink} sx={{ gap: 1 }}>
              <ContentCopy fontSize="small" />
              <ListItemText>Copy Link</ListItemText>
            </MuiMenuItem>
          </>}


        <MuiMenuItem onClick={() => openTableDialog(selectedTableForMenu)} sx={{ gap: 1 }}>
          <Edit fontSize="small" />
          <ListItemText>Edit Table</ListItemText>
        </MuiMenuItem>
        {selectedTableForMenu?.is_active && selectedTableForMenu.track.status === "FREE" &&
          <MuiMenuItem onClick={() => handleDeleteTable(selectedTableForMenu.id)} sx={{ gap: 1 }}>
            <ToggleOff fontSize="small" />
            <ListItemText>Deactivate Table</ListItemText>
          </MuiMenuItem>
        }

        {!selectedTableForMenu?.is_active &&
          <MuiMenuItem onClick={() => handleDeleteTable(selectedTableForMenu.id)} sx={{ gap: 1 }}>
            <ToggleOn fontSize="small" />
            <ListItemText>Activate Table</ListItemText>
          </MuiMenuItem>
        }

        {selectedTableForMenu?.is_active &&
          <MuiMenuItem onClick={handleDownloadQr} sx={{ gap: 1, borderTop: '1px solid', borderColor: 'divider' }}>
            <Download fontSize="small" />
            <ListItemText>Download QR</ListItemText>
          </MuiMenuItem>
        }

      </Menu>

      {/* Table Dialog */}
      <Dialog
        open={tableDialog}
        onClose={closeTableDialog}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{ sx: { maxHeight: isMobile ? '100vh' : '90vh', overflow: 'hidden' } }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Typography variant="h6" fontWeight={600}>
            {editingTable ? 'Edit Table' : 'Add New Table'}
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ overflow: 'auto', pb: 2 }}>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Table Name"
                value={tableForm.name}
                onChange={(e) => setTableForm({ ...tableForm, name: e.target.value })}
                required
                placeholder="e.g., Window Table, Garden View"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Table Number"
                value={tableForm.table_number}
                onChange={(e) => setTableForm({ ...tableForm, table_number: e.target.value })}
                required
                placeholder="e.g., T001, T002"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Capacity"
                type="number"
                value={tableForm.capacity}
                onChange={(e) => setTableForm({ ...tableForm, capacity: parseInt(e.target.value) })}
                inputProps={{ min: 1, max: 20 }}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Outlet</InputLabel>
                <Select
                  value={tableForm.outlet_id}
                  onChange={(e) => setTableForm({ ...tableForm, outlet_id: e.target.value })}
                  label="Outlet"
                  required
                >
                  {outlets.map((outlet) => (
                    <MenuItem key={outlet.id} value={outlet.id}>
                      {outlet.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* <Grid item xs={12}>
              <input accept="image/*" type="file" id="table-image" onChange={handleImageChange} style={{ display: 'none' }} />
              <label htmlFor="table-image">
                <Button variant="outlined" component="span" startIcon={<Image />} fullWidth>
                  {editingTable && editingTable.image_url ? 'Change Image' : 'Upload Image'}
                </Button>
              </label>
            </Grid> */}
            {/* {imagePreview && (
              <Grid item xs={12}>
                <Box sx={{ textAlign: 'center' }}>
                  <img src={imagePreview} alt="Table preview" style={{ maxWidth: '100%', maxHeight: 200, objectFit: 'cover', borderRadius: 8 }} />
                </Box>
              </Grid>
            )} */}
            {/* <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={<Switch checked={tableForm.is_active} onChange={(e) => setTableForm({ ...tableForm, is_active: e.target.checked })} />}
                label="Active"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={<Switch checked={tableForm.is_available} onChange={(e) => setTableForm({ ...tableForm, is_available: e.target.checked })} />}
                label="Available"
              />
            </Grid> */}
          </Grid>
        </DialogContent>

        <DialogActions sx={{ p: 2, pt: 1, gap: 1 }}>
          <Button onClick={closeTableDialog} disabled={submitting}>Cancel</Button>
          <Button
            onClick={handleSubmitTable}
            variant="contained"
            disabled={submitting || !tableForm.name || !tableForm.table_number || !tableForm.capacity || !tableForm.outlet_id}
            sx={{ minWidth: 120 }}
          >
            {submitting ? <CircularProgress size={20} /> : (editingTable ? 'Update' : 'Create')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Admin Response Dialog */}
      <Dialog open={responseDialog} onClose={() => setResponseDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Phone />
            <Typography variant="h6">Respond to Reservation</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedReservation && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom><strong>Customer:</strong> {selectedReservation.customer_name}</Typography>
              {selectedReservation?.customer_email && <Typography variant="body2" color="text.secondary" gutterBottom><strong>Email:</strong> {selectedReservation.customer_email}</Typography>}
              <Typography variant="body2" color="text.secondary" gutterBottom><strong>Phone:</strong> {selectedReservation.customer_phone}</Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom><strong>Date & Time:</strong> {selectedReservation.reservation_date} at {selectedReservation.reservation_time}</Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom><strong>Guests:</strong> {selectedReservation.guest_count}</Typography>
              {selectedReservation.special_requests && <Typography variant="body2" color="text.secondary" gutterBottom><strong>Special Requests:</strong> {selectedReservation.special_requests}</Typography>}
            </Box>
          )}
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Response Status</InputLabel>
                <Select
                  value={responseForm.status}
                  onChange={(e) => setResponseForm({ ...responseForm, status: e.target.value })}
                  label="Response Status"
                >
                  <MenuItem value="confirmed">Confirm Reservation</MenuItem>
                  <MenuItem value="cancelled">Cancel Reservation</MenuItem>
                  <MenuItem value="completed">Mark as Completed</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Admin Notes (Internal)"
                multiline
                rows={3}
                value={responseForm.admin_notes}
                onChange={(e) => setResponseForm({ ...responseForm, admin_notes: e.target.value })}
                placeholder="Internal notes for staff..."
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Response Message (Will be sent to customer)"
                multiline
                rows={3}
                value={responseForm.response_message}
                onChange={(e) => setResponseForm({ ...responseForm, response_message: e.target.value })}
                placeholder="Message to send to customer..."
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setResponseDialog(false)}>Cancel</Button>
          <Button onClick={handleResponseSubmit} variant="contained" color="primary">Send Response</Button>
        </DialogActions>
      </Dialog>

      {/* Table Assignment Dialog */}
      <Dialog open={assignTableDialog} onClose={() => setAssignTableDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TableRestaurant />
            <Typography variant="h6">Assign Table to Request</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedRequest && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom><strong>Customer:</strong> {selectedRequest.customer_name}</Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom><strong>Phone:</strong> {selectedRequest.customer_phone}</Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom><strong>Date & Time:</strong> {selectedRequest.reservation_date} at {selectedRequest.reservation_time}</Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom><strong>Guests:</strong> {selectedRequest.guest_count}</Typography>
              {selectedRequest.occasion && <Typography variant="body2" color="text.secondary" gutterBottom><strong>Occasion:</strong> {selectedRequest.occasion}</Typography>}
              {selectedRequest.special_requests && <Typography variant="body2" color="text.secondary" gutterBottom><strong>Special Requests:</strong> {selectedRequest.special_requests}</Typography>}
            </Box>
          )}
          <FormControl fullWidth>
            <InputLabel>Select Table</InputLabel>
            <Select
              value={selectedTableForRequest}
              onChange={(e) => setSelectedTableForRequest(e.target.value)}
              label="Select Table"
            >
              {tables.filter(table => table.is_active && table.is_available).map((table) => (
                <MenuItem key={table.id} value={table.id}>
                  {table.name} ({table.table_number}) - {table.capacity} seats
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAssignTableDialog(false)}>Cancel</Button>
          <Button onClick={handleAssignTable} variant="contained" color="primary" disabled={!selectedTableForRequest}>Assign Table</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TableAdditionManagement;